const initialState = {
	postId: null,
	list: [],
	page: 1,
	isListNext: false,
	datetime: null,
  scrollpos: 0,
};

export default function reducer(state = initialState, action) {

	if (action.type === 'MY_POST_GOOD_USER_LIST_SET') {
		let newState = Object.assign({}, state);
		newState.postId = action.payload.postId;
		newState.list = action.payload.list;
		newState.page = action.payload.page;
		newState.isListNext = action.payload.isListNext;
		newState.scrollpos = 0;
		newState.datetime = (new Date());
		return newState;
	}
	else if (action.type === 'MY_POST_GOOD_USER_LIST_INIT') {
		let newState = Object.assign({}, state);
		newState = initialState;
		return newState;
	}
	else if (action.type === 'MY_POST_GOOD_USER_LIST_SCROLLPOS_SET') {
		let newState = Object.assign({}, state);
		newState.scrollpos = action.payload.scrollpos;
		return newState;
	}
	else {
		return state;
	}
}
